var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit_item" },
    [
      _c("my_slider", {
        attrs: {
          titleWidth: "54",
          title: _vm.title,
          value: _vm.result,
          min: 0,
          max: 100,
          symbol: "%",
        },
        on: {
          "update:value": function ($event) {
            _vm.result = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }